import React from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export function ResumeSection({ title, children, className = '' }: Props) {
  return (
    <section className={`resume-section ${className}`}>
      <h2 className="resume-section-title">{title}</h2>
      {children}
    </section>
  );
}
